import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import "./assets/css/font.css";
import "./assets/css/styles.scss";
import "./plugins/axios";

import Iconify from "./components/Iconify";
import Divcard from "./components/Divcard";
import VueSignaturePad from "vue-signature-pad";
import axios from "axios";
import { apiDomain } from "./store/constants";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import TooltipText from "./components/TooltipText.vue";
var VueCookie = require("vue-cookie");
Vue.use(VueCookie);

Vue.use(VueSweetalert2);
Vue.use(HighchartsVue);

Vue.use(require("vue-moment"));
Vue.use(VueSignaturePad);
Vue.component("Iconify", Iconify);
Vue.component("divcard", Divcard);
Vue.component("TooltipText", TooltipText);

// prod config
Vue.config.productionTip = false;
// console.log = () => {}

// apiFire using dispatch
Vue.prototype.$apiFire = async (
  dispatch,
  payload = undefined,
  fullResponse = false
) => {
  // check token
  // if (!getCookie__c('session_login') || !JSON.parse(getCookie__c('session_login')).token) {
  //   return reLogin()
  // }
  store.commit("General/setLoading");
  await axios({
    url: apiDomain + "sanctum/csrf-cookie",
    method: "GET",
  });

  let res = await store.dispatch(dispatch, {
    payload,
    // token: JSON.parse(getCookie__c('session_login')).token,
    fullResponse,
  });
  store.commit("General/setLoading", false);
  return res;
};

export function reLogin(text) {
  store.commit("General/setModal", {
    title: "Oops!",
    buttonText: "ยืนยัน",
    showCancel: false,
    text,
    action: () => {
      store.commit("Auth/clearUserInfo");
      window.location.href = "/";
    },
  });
}

export function checkAndReturn(data, res, noData = false) {
  try {
    if (res.data && res.status === 200) {
      if (data.fullResponse) return res.data;
      return noData ? res.data : res.data.data;
    }

    if (res.status === 400 || res.status === 404 || res.status === 500) {
      let title;

      switch (res.status) {
        case 400:
          title = "ผิดพลาด";
          break;
        case 404:
          title = "ไม่พบข้อมูล";
          break;
        case 500:
          title = "Something went wrong!";
          break;
        default:
          title = "ผิดพลาด";
      }

      store.commit("General/setModal", {
        title: title,
        showCancel: false,
        theme: "error",
        text: res.data.message,
        buttonText: "ตกลง",
      });

      return false;
    }

    if (res.status === 401) {
      return reLogin(res.data.message);
    }

    if (res.status === 422) {
      let err = Object.values(res.data.errors);

      store.commit("General/setModal", {
        title: "ข้อมูลไม่ถูกต้อง",
        showCancel: false,
        theme: "warning",
        text: err,
        buttonText: "ตกลง",
      });

      return err;
    }

    return false;
  } catch (err) {
    store.commit("General/setModal", {
      title: "ผิดพลาด",
      showCancel: false,
      theme: "warning",
      text: err,
      buttonText: "ตกลง",
    });
    return false;
  }
}

const v = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

// when router is ready then render app
router.onReady(() => {
  v.$mount("#app");
});
